var _circle, _circle2, _circle3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgHideNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#F8696E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59.5C50 55.8086 52.9531 52.75 56.75 52.75H97.25C100.941 52.75 104 55.8086 104 59.5V89.875C104 93.6719 100.941 96.625 97.25 96.625H82.5898L69.5117 106.434C68.9844 106.855 68.3516 106.855 67.7188 106.645C67.1914 106.328 66.875 105.801 66.875 105.062V96.625H56.75C52.9531 96.625 50 93.6719 50 89.875V59.5ZM72.8867 69.7305C73.8359 68.7812 73.8359 67.1992 72.8867 66.25C71.832 65.1953 70.25 65.1953 69.3008 66.25L62.5508 73C61.4961 73.9492 61.4961 75.5312 62.5508 76.4805L69.3008 83.2305C70.25 84.2852 71.832 84.2852 72.8867 83.2305C73.8359 82.2812 73.8359 80.6992 72.8867 79.75L67.9297 74.793L72.8867 69.8359V69.7305ZM84.6992 66.1445C83.6445 65.1953 82.0625 65.1953 81.1133 66.1445C80.0586 67.1992 80.0586 68.7812 81.1133 69.7305L86.0703 74.6875L81.1133 79.6445C80.0586 80.6992 80.0586 82.2812 81.1133 83.2305C82.0625 84.2852 83.6445 84.2852 84.6992 83.2305L91.4492 76.4805C92.3984 75.5312 92.3984 73.9492 91.4492 72.8945L84.6992 66.1445Z",
    fill: "url(#paint0_linear_15085_294158)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15085_294158",
    x1: 77,
    y1: 53,
    x2: 77,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHideNotification);
export default __webpack_public_path__ + "static/media/img_hide_notification.9a25f58af6156e6f928e67c20de2e854.svg";
export { ForwardRef as ReactComponent };